<template>
  <v-app>
    <v-snackbar
      class="body-1"
      v-model="snackbar"
      :color="snackbarColor"
      :multi-line="false"
      :timeout="snackbarTimeout"
    >
      {{ snackbarMessage }}
      <v-btn dark text @click="snackbar = false" x-large>Close</v-btn>
    </v-snackbar>
    <v-navigation-drawer v-model="drawer" app clipped :width="320">
      <v-container fill-height class="ma-0 pa-0">
        <v-expansion-panels class="align-self-start main-menu" v-model="panel" :accordion="true">
          <v-expansion-panel>
            <v-expansion-panel-header class="py-2">
              <span class="text-uppercase title">Set-top-boxes</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list shaped>
                <v-list-item-group v-model="configRouteBase.value" mandatory>
                  <v-list-item
                    v-for="item in configRouteBase.items"
                    :key="item.value"
                    :value="item.value"
                    :to="item.value + '/' + encodeURIComponent(JSON.stringify(configRouteTag.values))"
                    dense
                  >
                    <v-list-item-icon>
                      <v-icon left>{{item.icon}}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{item.text}}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <v-card class="ma-2">
                <v-card-subtitle class="py-2">Filter entries by tag:</v-card-subtitle>
                <v-card-text class="pb-0">
                  <v-chip-group column v-model="configRouteTag.values" multiple>
                    <v-chip
                      v-for="item in configRouteTag.items"
                      :key="item"
                      :value="item"
                      label
                      close
                      filter
                      @click:close="configRouteTagRemove(item)"
                    >
                      <v-icon left>mdi-tag</v-icon>
                      {{item}}
                    </v-chip>
                  </v-chip-group>
                  <v-select
                    v-model="configAddTagValue"
                    :items="configTagList"
                    item-text="text"
                    item-value="value"
                    label="Add a tag"
                    clearable
                    dense
                  ></v-select>
                </v-card-text>
              </v-card>
              <v-list shaped>
                <v-list-item-group>
                  <v-list-item
                    dense
                    target="_blank"
                    href="https://confluence.tv.sfr.net/pages/viewpage.action?pageId=117083231#Serveurdemise%C3%A0jourSet-top-box(environnementdetest)-D%C3%A9tailsdesversions"
                  >
                    <v-list-item-icon>
                      <v-icon left>mdi-lifebuoy</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Help about SW versions</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <v-container pt-0>
                <v-text-field
                  label="STB MAC address or ID"
                  ref="newSetTopBoxId"
                  :rules="newSetTopBoxIdRules"
                  v-model="newSetTopBoxId"
                  @keypress.enter="stbConfigAdd"
                >
                  <template v-slot:append>
                    <v-btn
                      text
                      depressed
                      tile
                      class="ma-0"
                      @click="stbConfigAdd"
                      :disabled="!stbConfigAddEnable"
                      outlined
                    >
                      <v-icon left>mdi-server-plus</v-icon>Add
                    </v-btn>
                  </template>
                </v-text-field>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-if="userIsAdmin">
            <v-expansion-panel-header class="py-2">
              <span class="text-uppercase title">Users</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list shaped>
                <v-list-item-group>
                  <v-list-item to="/app/users/list">
                    <v-list-item-icon>
                      <v-icon left>mdi-server</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>User list</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <v-container py-0>
                <v-text-field
                  label="email or username"
                  ref="newUserId"
                  v-model="newUserId"
                  :rules="newUserIdRules"
                  @keypress.enter="userAdd"
                >
                  <template v-slot:append>
                    <v-btn
                      text
                      depressed
                      tile
                      class="ma-0"
                      @click="userAdd"
                      :disabled="!userAddEnable"
                      outlined
                    >
                      <v-icon left>mdi-account-plus</v-icon>Add
                    </v-btn>
                  </template>
                </v-text-field>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="py-2">
              <span class="text-uppercase title">Groups</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list shaped>
                <v-list-item-group>
                  <v-list-item to="/app/groups/list">
                    <v-list-item-icon>
                      <v-icon left>mdi-server</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Group list</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <v-container py-0>
                <v-text-field
                  label="Group ID"
                  ref="newGroupId"
                  v-model="newGroupId"
                  :rules="newGroupIdRules"
                  @keypress.enter="groupAdd"
                >
                  <template v-slot:append>
                    <v-btn
                      text
                      depressed
                      tile
                      class="ma-0"
                      @click="groupAdd"
                      :disabled="!groupAddEnable"
                      outlined
                    >
                      <v-icon left>mdi-account-plus</v-icon>Add
                    </v-btn>
                  </template>
                </v-text-field>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-img class="align-self-end" src="sfr.png"></v-img>
      </v-container>
    </v-navigation-drawer>
    <v-app-bar clipped-left app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-autocomplete
        label="Find a set-top-box configuration"
        clearable
        v-model="stbConfig.value"
        :items="stbConfig.items"
        :loading="stbConfig.loading"
        :search-input.sync="stbConfig.search"
        item-text="text"
        item-value="value"
        class="px-3 pt-6"
        dense
      ></v-autocomplete>
      <v-autocomplete
        label="Find an user"
        clearable
        v-model="user.value"
        :items="user.items"
        :loading="user.loading"
        :search-input.sync="user.search"
        item-text="text"
        item-value="value"
        class="px-3 pt-6"
        dense
        v-if="userIsAdmin"
      ></v-autocomplete>
      <v-menu v-model="userMenu" :close-on-content-click="false" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>
        <v-card min-width="320px">
          <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <v-avatar color="blue-grey">
                  <span class="white--text headline">{{ userInitials }}</span>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ userDisplayName }}</v-list-item-title>
                <v-list-item-subtitle>{{ userId }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-list>
            <v-list-item to="/app/tokens/list" dense>
              <v-list-item-icon>
                <v-icon left>mdi-key-change</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Manage tokens</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-switch v-model="themeDarkModeEnabled"></v-switch>
              </v-list-item-action>
              <v-list-item-title>Dark mode</v-list-item-title>
            </v-list-item>
          </v-list>
          <v-card-actions>
            <v-btn color="primary" @click="userProfileEditorOpen">
              <v-icon>mdi-square-edit-outline</v-icon>User profile
            </v-btn>
            <v-btn color="red" outlined @click="logout">
              <v-icon>mdi-logout</v-icon>Logout
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-content>
      <router-view @error="processErrorResponse" @success="displaySuccess" @close="mainViewClose"></router-view>
    </v-content>
    <v-footer app>
      <span>&copy; 2021 SFR STB MW TEAM - version {{version}}</span>
    </v-footer>
    <v-dialog v-model="userProfileEditor" width="unset">
      <UserProfile
        @close="userProfileEditorClose"
        @error="processErrorResponse"
        @success="displaySuccess"
      ></UserProfile>
    </v-dialog>
  </v-app>
</template>

<style>
.main-menu .v-expansion-panel-content__wrap {
  padding: 0px;
}
</style>

<script>
const version = require("../../package.json").version;

import UserProfile from "../components/UserProfile.vue";
import {
  checkNested,
  getLocalParam,
  setLocalParam,
  autocompleteListUpdate,
  vAutoCompDefData,
  getTextFromUserRecord
} from "./../lib";

export default {
  name: "MainWindow",
  components: { UserProfile },
  data: () => ({
    configRouteBase: {
      items: [
        {
          icon: "mdi-server",
          text: "Configurations (list view)",
          value: "/app/configs/list/user",
          user: true
        },
        {
          icon: "mdi-view-grid",
          text: "Configurations (grid view)",
          value: "/app/configs/grid/user",
          user: true
        }
      ],
      value: "/app/configs/list/user"
    },
    configRouteTag: {
      items: getLocalParam("settings.main.menuTags", []),
      values: []
    },
    configAddTagValue: null,
    panel: 0,
    panelConfig: 0,
    drawer: null,
    themeDarkModeEnabled: true,
    userMenu: false,
    newSetTopBoxId: "",
    newSetTopBoxIdRules: [
      v =>
        /^([0-9a-fA-F]{2}[-:]?[0-9a-fA-F]{2}[-:]?[0-9a-fA-F]{2}[-:]?[0-9a-fA-F]{2}[-:]?[0-9a-fA-F]{2}[-:]?[0-9a-fA-F]{2})?$/.test(
          v
        ) || "Set-top-box ID must be valid"
    ],
    newUserId: "",
    newUserIdRules: [
      v =>
        /^(\w+([.-]?\w+)*(@\w+([.-]?\w+)*(\.\w{2,3})+)?)?$/.test(v) ||
        "Bad username or email format"
    ],
    newGroupId: "",
    newGroupIdRules: [v => /^(\w+([.-]?\w+))?$/.test(v) || "Bad group name"],
    snackbar: false,
    snackbarColor: "red darken-3",
    snackbarTimeout: 6000,
    snackbarMessage: "",
    user: Object.assign(vAutoCompDefData(), {
      rest: {
        path: () => "/users",
        args: {
          sort_asc: true,
          limit: 20
        },
        mapCallback: e => ({
          value: e.user_id,
          text: getTextFromUserRecord(e)
        })
      }
    }),
    stbConfig: Object.assign(vAutoCompDefData(), {
      rest: {
        path: () => "/configs",
        args: {
          sort_asc: true,
          limit: 20
        },
        mapCallback: e => ({
          value: e.set_top_box_id,
          text: `${e.label} [${e.set_top_box_id.match(/.{2}/g).join(":")}] (${
            e.set_top_box_id
          })`
        })
      }
    }),
    userProfileEditor: false,
    version: version
  }),
  computed: {
    userDisplayName() {
      return this.$store.getters.userDisplayName;
    },
    userId() {
      return this.$store.getters.userId;
    },
    userIsAdmin() {
      return this.$store.getters.userIsAdmin;
    },
    userInitials() {
      const initials =
        this.$store.getters.userDisplayName
          .replace(/(\.prestataire)?@.*/, "")
          .match(/\b\w/g) || [];
      return ((initials.shift() || "") + (initials.pop() || "")).toUpperCase();
    },
    textAvatarColor() {
      return "#" + ((Math.random() * 0xffffff) << 0).toString(16);
    },
    stbConfigAddEnable() {
      return this.newSetTopBoxId && this.$refs.newSetTopBoxId.validate();
    },
    userAddEnable() {
      return this.newUserId && this.$refs.newUserId.validate();
    },
    groupAddEnable() {
      return this.newGroupId && this.$refs.newGroupId.validate();
    },
    configTagList() {
      return this.$store.getters.configTagList.filter(
        e => this.configRouteTag.items.indexOf(e) === -1
      );
    }
  },
  watch: {
    "configRouteTag.values": function(values) {
      if (values && this.configRouteBase.value) {
        this.$router.push(
          this.configRouteBase.value +
            "/" +
            encodeURIComponent(JSON.stringify(values))
        );
      }
    },
    "configRouteTag.items": function(value) {
      setLocalParam("settings.main.menuTags", value);
    },
    configAddTagValue: function(value) {
      if (value && this.configRouteTag.items.indexOf(value) === -1) {
        this.configRouteTag.items.push(value);
        this.configAddTagValue = null;
      }
    },
    themeDarkModeEnabled: function(val) {
      this.$vuetify.theme.dark = val;
      this.$store.commit("dark_mode", val);
    },
    "stbConfig.search": function(value) {
      if (value)
        this.updateList("stbConfig", value.replace(/([a-fA-F0-9]+):/g, "$1"));
    },
    "stbConfig.value": function(value) {
      if (value) {
        this.stbConfigOpen(value);
        this.stbConfig.value = "";
      }
    },
    "user.search": function(value) {
      if (value) this.updateList("user", value);
    },
    "user.value": function(value) {
      if (value) {
        this.userOpen(value);
        this.user.value = "";
      }
    }
  },
  methods: {
    processErrorResponse(result) {
      if (
        checkNested(result, "response", "status") &&
        result.response.status === 401
      ) {
        this.logout();
        return;
      }
      if (checkNested(result, "response", "data", "error", "message")) {
        this.displayError(result.response.data.error.message);
      } else if (checkNested(result, "message")) {
        this.displayError(result.message);
      } else {
        this.displayError(result);
      }
    },
    displayError(message) {
      this.snackbarColor = "red darken-3";
      this.snackbarMessage = message;
      this.snackbar = true;
    },
    displaySuccess(message) {
      this.snackbarColor = "success";
      this.snackbarMessage = message;
      this.snackbar = true;
    },
    configRouteTagRemove(value) {
      this.configRouteTag.items.splice(
        this.configRouteTag.items.indexOf(value),
        1
      );
    },
    mainViewClose() {
      this.$router.go(-1);
    },
    userProfileEditorClose() {
      this.userProfileEditor = false;
    },
    userProfileEditorOpen() {
      this.userMenu = false;
      this.userProfileEditor = true;
    },
    logout() {
      this.$store.dispatch("logout").then(() => this.$router.push("/login"));
    },
    stbConfigAdd() {
      if (this.newSetTopBoxId && this.$refs.newSetTopBoxId.validate()) {
        const id = this.newSetTopBoxId.replace(/[-:]/g, "").toLowerCase();
        this.$axios
          .post("/configs/", {
            set_top_box_id: id,
            owner_id: this.$store.getters.userId,
            properties: {}
          })
          .then(() => {
            this.displaySuccess(
              `Set-top-box configuration ${id} successfully added!`
            );
            this.newSetTopBoxId = "";
            this.stbConfigOpen(id);
          })
          .catch(result => this.processErrorResponse(result));
      }
    },
    stbConfigOpen(id) {
      const layout = getLocalParam("settings.configList.layout", "list");
      const listType = getLocalParam("settings.configList.listType", "user");
      this.$router.push(
        `/app/configs/${layout}/${listType}/${encodeURIComponent(
          JSON.stringify(this.configRouteTag.values)
        )}/${id}`
      );
    },
    userAdd() {
      if (this.$refs.newUserId.validate()) {
        const id = this.newUserId.toLowerCase();
        this.$axios
          .post("/users/", {
            user_id: id,
            access_level: "None"
          })
          .then(() => {
            this.displaySuccess(`User ${id} successfully added!`);
            this.newUserId = "";
            this.userOpen(id);
          })
          .catch(result => this.processErrorResponse(result));
      }
    },
    userOpen(id) {
      const layout = getLocalParam("settings.userList.layout", "list");
      this.$router.push(`/app/users/${layout}/${id}`);
    },
    updateList(name, filter) {
      autocompleteListUpdate(this, name, filter);
    },
    groupAdd() {
      if (this.$refs.newGroupId.validate()) {
        const id = this.newGroupId.toLowerCase();
        this.$axios
          .post("/groups/", {
            group_id: id,
            owner_id: this.$store.getters.userId
          })
          .then(() => {
            this.displaySuccess(`Group ${id} successfully added!`);
            this.newGroupId = "";
            this.groupOpen(id);
          })
          .catch(result => this.processErrorResponse(result));
      }
    },
    groupOpen(id) {
      const layout = getLocalParam("settings.groupList.layout", "list");
      this.$router.push(`/app/groups/${layout}/${id}`);
    }
  },
  created() {
    this.themeDarkModeEnabled = this.$store.state.themeDarkEnabled;
    this.$vuetify.theme.dark = this.$store.state.themeDarkEnabled;
    this.stbConfig.rest.args.global = this.userIsAdmin;
    if (this.userIsAdmin) {
      this.configRouteBase.items.push({
        icon: "mdi-server",
        text: "Global configuration list",
        value: "/app/configs/list/global"
      });
    }
  }
};
</script>
